/* eslint-disable no-param-reassign,@typescript-eslint/no-shadow,no-underscore-dangle,@typescript-eslint/no-unused-vars */

import { shareReplay } from 'rxjs/operators';
import { updateAccountInfo } from '../../../../app/account/store/account.actions';
import { EVENTS } from '../../../../app/constants/events';
import { DESIGNER_SETTINGS } from '../../../../app/constants/designer_settings';
import { getConnectionTypes } from '../../../../app/connections/store/connections.actions';

xplenty.controller('account.controller', [
  '$scope',
  '$rootScope',
  '$state',
  '$stateParams',
  '$translate',
  '$timeout',
  '$q',
  'connectionsService',
  'Account',
  'Connection',
  'Package',
  'User',
  'Job',
  'Variable',
  'segment',
  'pusherService',
  'notify',
  'permissionService',
  'Rollbar',
  'ngrxStoreService',
  'modalService',
  'accountService',
  function (
    $scope,
    $rootScope,
    $state,
    $stateParams,
    $translate,
    $timeout,
    $q,
    connectionsService,
    Account,
    Connection,
    Package,
    User,
    Job,
    Variable,
    segment,
    pusherService,
    notify,
    permissionService,
    Rollbar,
    ngrxStoreService,
    modalService,
    accountService,
  ) {
    $rootScope.account = {};
    window.localStorage.setItem('account_id', $stateParams.account_id);

    $rootScope.loadingAccount = true;

    connectionsService.init();
    ngrxStoreService.dispatch(getConnectionTypes());

    ngrxStoreService.dispatch(updateAccountInfo({ account: { account_id: $stateParams.account_id } }));

    Account.get($stateParams.account_id, { include: 'event_traits,partner' }).subscribe(
      (account) => {
        if (window.NODE_ENV !== 'development') {
          Rollbar.configure({
            payload: {
              person: {
                id: account.id,
                username: account.account_id,
              },
            },
          });
        }
        $rootScope.$log.info('Account information loaded');
        $rootScope.account = account;
        $rootScope.isWorkspacesFeatureEnabled = account.workspaces_feature_enabled;
        ngrxStoreService.dispatch(updateAccountInfo({ account }));
        $rootScope.loadingAccount = false;
        segment.group($rootScope.account.id, $rootScope.account.event_traits);
        pusherService.initAccount(account.id);
        $rootScope.$broadcast(EVENTS.ACCOUNT_LOADED, account);

        accountService.currentAccount = account;
        permissionService.init([...accountService.accounts, account]);
      },
      function (res) {
        notify.error(null, 'Error occurred while loading an account data.');
      },
    );

    // Precache of system variables
    Variable.get().subscribe(
      function (systemVariables) {
        $rootScope.$log.info('Variables loaded');
        $rootScope._systemVariables = systemVariables;
      },
      function () {
        notify.error(null, 'Failed to load system variables');
      },
    );

    $rootScope.hideModal = () => {
      modalService.hideModal();
    };

    // CONNECTIONS
    $rootScope.createConnection = function (connection, callback, error) {
      const observableCall = Connection.save(connection).pipe(shareReplay(1));
      observableCall.subscribe(
        function (res) {
          if (callback) callback(res);
        },
        function (res) {
          if (error) error(res);
        },
      );
      return observableCall;
    };

    $rootScope.createPackage = function (_package, callback, error) {
      if (_package.package_template_id === 'blank') delete _package.package_template_id;
      if (_package.flow_type === 'workflow') _package.flow_version = DESIGNER_SETTINGS.FLOW_VERSION;
      else _package.flow_version = DESIGNER_SETTINGS.OLD_FLOW_VERSION;
      if ($state.params.workspace_id) {
        _package.workspace_id = $state.params.workspace_id;
      }

      const observableCall = Package.save(_package, {
        include: 'owner,workspace',
      }).pipe(shareReplay(1));
      observableCall.subscribe(
        function (res) {
          if (callback) callback(res);
        },
        function (res) {
          if (error) error(res);
        },
      );
      return observableCall;
    };

    $rootScope.removePackage = function (_package, callback, error) {
      const observableCall = Package.remove(_package.id).pipe(shareReplay(1));
      observableCall.subscribe(
        function (res) {
          if (callback) callback(res);
        },
        function (res) {
          if (error) error(res);
        },
      );
      return observableCall;
    };

    $rootScope.createJob = function (job, callback, error) {
      const observableCall = Job.save(job, {
        include: 'package,cluster',
      }).pipe(shareReplay(1));
      observableCall.subscribe(
        function (job) {
          if (callback) callback(job);
        },
        function (res) {
          if (error) error(res);
        },
      );
      return observableCall;
    };
  },
]);
